export class RegionSuggestionController {
    public error: string;
    public loading = true;
    public regionSuggestions: any;

    public static $inject = ["RegionSuggestionService"];
    constructor(private RegionSuggestionService) {}

    private $onInit() {
        this.RegionSuggestionService.get()
            .$promise.then(data => {
                this.convertData(data);
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
                this.error = "An error occurred. Sorry.";
            });
    }

    private convertData(data) {
        const list: any[] = [];
        let item: any;
        let root: any;
        let current: any;
        let parent: any;
        const result: any[] = [];
        let currentList: any[];
        let references: any[] = [];
        const global: any = {
            name: "Global",
            page: "global",
            key: "global",
            references: [],
            parent: null,
        };

        for (const key in data) {
            if (!data.hasOwnProperty(key) && typeof data[key] !== "object") {
                continue;
            }

            // Filter $promise
            if (key.indexOf("$") !== -1) {
                continue;
            }

            data[key].key = key;
            item = data[key];
            list.push(item);
        }

        if (!list.length) {
            this.regionSuggestions = false;
            return;
        }

        // Last in result list
        root = list
            .filter(function(item) {
                return item.parent === null;
            })
            .pop();

        // First in result list
        currentList = list.filter(function(item) {
            return item.parent !== null && item.parent !== root.key;
        });

        if (!currentList.length) {
            current = list
                .filter(function(item) {
                    return item.parent === root.key;
                })
                .pop();
        } else {
            current = currentList.pop();
            parent = data[current.parent];
        }
        // Get references
        if (current.references.length) {
            references = list.filter(function(item) {
                return current.references.indexOf(item.key) !== -1;
            });
        }

        // Build result
        result.push(current);

        if (parent) {
            result.push(parent);
        }

        while (references.length) {
            result.push(references.shift());
        }

        result.push(root);
        result.push(global);
        this.regionSuggestions = result;
    }
}
